"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ZonesInteractiveMap = _interopRequireDefault(require("./ZonesInteractiveMap"));
var _utils = require("../../../services/ui/utils");
var _AdvancedModal = _interopRequireDefault(require("../../AdvancedModal"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _pages = require("chaire-lib-frontend/lib/components/pages");
var aggregatedzones = _interopRequireWildcard(require("../../../config/zonesSelection.json"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // this file contains SM id of aggrgetation i.e. mtl island north shore and south shore
class SpatialFilterMap extends _react.default.Component {
  constructor(props) {
    super(props);
    this.mapRef = /*#__PURE__*/_react.default.createRef();
    this.state = {
      //map variables
      filterSelected: _OctaviParameters.default.get('filterSelected', "FilterOne"),
      filters: _OctaviParameters.default.filters,
      currentZoneMapState: {},
      isActive: false,
      isEnabled: _ServiceLocator.default.collectionManager.has('zones'),
      zoneType: null
    };

    // this.zone_data = { features: [], type    : "FeatureCollection" }
    this.zone_data = this.loadZones_lvl1();
    this.updateFilter = this.updateFilter.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOriginOpen = this.handleOriginOpen.bind(this);
    this.handleDestinationOpen = this.handleDestinationOpen.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.updateFilterSelection = this.updateFilterSelection.bind(this);
    this.updateZoneSelection = this.updateZoneSelection.bind(this);
    this.enableSpatialFilter = this.enableSpatialFilter.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.on('taxi.filter.data.update', this.updateFilter);
    _ServiceLocator.default.eventManager.on("taxi.filter.selectOrigin.request", this.handleOriginOpen);
    _ServiceLocator.default.eventManager.on("taxi.filter.selectDestination.request", this.handleDestinationOpen);
    _ServiceLocator.default.eventManager.on('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.on("octaviZones.selection", this.updateZoneSelection);
    _ServiceLocator.default.eventManager.on("taxi.filter.spatial.enable", this.enableSpatialFilter);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.off('taxi.filter.data.update', this.updateFilter);
    _ServiceLocator.default.eventManager.off("taxi.filter.selectOrigin.request", this.handleOriginOpen);
    _ServiceLocator.default.eventManager.off("taxi.filter.selectDestination.request", this.handleDestinationOpen);
    _ServiceLocator.default.eventManager.off('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.off("octaviZones.selection", this.updateZoneSelection);
    _ServiceLocator.default.eventManager.off("taxi.filter.spatial.enable", this.enableSpatialFilter);
  }
  updateFilter() {
    this.setState({
      filters: _OctaviParameters.default.filters
    });
  }
  updateFilterSelection() {
    this.setState({
      filterSelected: _OctaviParameters.default.filterSelected
    });
  }
  updateZoneSelection(selection) {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const {
      origin,
      destination
    } = selection;
    const newFilters = (0, _toConsumableArray2.default)(this.state.filters);
    newFilters[filterIdx][`selectedOriginDistricts`] = origin;
    newFilters[filterIdx][`selectedDestinationDistricts`] = destination;
    this.setState({
      filters: newFilters
    });
  }
  handleClose() {
    this.setState({
      isActive: false
    });
  }
  handleOriginOpen() {
    this.setState({
      isActive: true,
      zoneType: "origin"
    });
  }
  handleDestinationOpen() {
    this.setState({
      isActive: true,
      zoneType: "destination"
    });
  }
  handleConfirm() {
    const newFilters = (0, _toConsumableArray2.default)(this.state.filters);

    // update octavi parameters
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  enableSpatialFilter() {
    this.zone_data = this.loadZones_lvl1();
    this.setState({
      isEnabled: true
    });
  }
  loadZones_lvl1() {
    let features = _ServiceLocator.default.collectionManager.has('zones') ? _ServiceLocator.default.collectionManager.get('zones').features : [];
    features = this.addFeaturesDataProp('SM', features);
    return {
      features: features,
      type: "FeatureCollection"
    };
  }
  addFeaturesDataProp(propName, features) {
    return features.map(function (item) {
      const newProps = _objectSpread({}, item.properties);
      newProps[propName] = item.properties.data[propName];
      return _objectSpread(_objectSpread({}, item), {}, {
        properties: newProps
      });
    });
  }
  renderContainer() {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const selected = {
      origin: this.state.filters[filterIdx] && this.state.filters[filterIdx][`selectedOriginDistricts`] ? this.state.filters[filterIdx][`selectedOriginDistricts`] : [],
      destination: this.state.filters[filterIdx] && this.state.filters[filterIdx][`selectedDestinationDistricts`] ? this.state.filters[filterIdx][`selectedDestinationDistricts`] : []
    };
    const groupedZones = [{
      name: "northShore",
      ids: aggregatedzones.northShore,
      propName: "SM"
    }, {
      name: "southShore",
      ids: aggregatedzones.southShore,
      propName: "SM"
    }, {
      name: "mtl",
      ids: aggregatedzones.mtl,
      propName: "SM"
    }, {
      name: "outterCMM",
      ids: ["noMatchFound"],
      propName: "raw"
    }];
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "80vw",
        height: "70vh",
        position: "relative"
      }
    }, this.state.isEnabled && /*#__PURE__*/_react.default.createElement(_ZonesInteractiveMap.default, {
      t: this.props.t,
      data: this.zone_data,
      lvl_0_label_key: "SR",
      aggregations: [{
        level: 1,
        aggregator: "SM",
        label_key: "SM_name"
      }],
      aggregationLocalPrefix: "octavi:filters:spatial:mapAggregation",
      defaultLevel: 1,
      section: this.props.activeSection,
      style: {
        height: "100%",
        zIndex: 2,
        position: "absolute"
      },
      selected: selected,
      allowComplexUi: true,
      zoneType: this.state.zoneType,
      groupedZones: groupedZones,
      groupedZonesLocalPrefix: "octavi:filters:spatial:groupedZones"
    }), !this.state.isEnabled && /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, {
      message: this.props.t('octavi:filters:spatial:message:MapLoading')
    }));
  }
  render() {
    const {
      isActive
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_AdvancedModal.default, {
      title: this.props.t('octavi:filters:spatial:map'),
      t: this.props.t,
      isOpen: isActive,
      container: this.renderContainer(),
      showCancelButton: true,
      showConfirmButton: true,
      closeModal: this.handleClose,
      confirmAction: this.handleConfirm,
      isConfirmButtonDisabled: false
    });
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(SpatialFilterMap);
SpatialFilterMap.propTypes = {
  activeSection: _propTypes.default.string
};